import React, { useState } from 'react';
import { auth, signInWithEmailAndPassword } from '../firebase';

const LoginForm = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState(''); // Username field can be replaced by email
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic form validation
    if (!username || !password) {
      setError('Please enter both email and password.');
      return;
    }

    // Firebase login logic
    signInWithEmailAndPassword(auth, username, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log('User logged in:', user);
        setError(''); // Reset error on successful login
        if (onLoginSuccess) onLoginSuccess();
        alert('Login successful!'); // Optional: You could redirect here or trigger other actions
      })
      .catch((error) => {
        const errorMessage = error.message;
        setError(`Login error: ${errorMessage}`);
        console.error('Login error:', errorMessage);
      });
  };

  return (
    <form onSubmit={handleSubmit} style={formStyle}>
      <h2>Login to Your Portfolio</h2>

      {error && <div style={errorStyle}>{error}</div>}

      <input
        type="email" // Change from "text" to "email" for better validation
        placeholder="Email"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        style={inputStyle}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={inputStyle}
      />

      <button type="submit" style={buttonStyle}>Login</button>
    </form>
  );
};

// Inline styles (as you had them)
const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  width: '100%',
  maxWidth: '400px',
  margin: 'auto',
  padding: '20px',
};

const inputStyle = {
  padding: '10px',
  fontSize: '16px',
  border: '1px solid #ccc',
  borderRadius: '6px',
};

const buttonStyle = {
  padding: '12px',
  fontSize: '16px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

const errorStyle = {
  color: 'red',
  fontSize: '14px',
};

export default LoginForm;
